import Yup from "../../services/Legacy/yup";

const assists_evolutions_schema = Yup.object().shape({
  evolution: Yup.string().required().label("evolução"),
});

export default assists_evolutions_schema;
